module.exports = __webpack_public_path__ + "static/media/Yes Man.60783579.jpg";